// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Plus Jakarta Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
:root {
  --indigo: #052456;
  --grey: #efefef;
  --border: #e3e3e3;
  --white: #fff;
  --validationError: #f32121;
  --orange: #f15e22;
  --diabledBtn: #ffa37d;
}
button,
select,
input[type="checkbox"] {
  cursor: pointer;
}
.error {
  color: var(--validationError);
  margin-top: 4px;
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;;;;;;EAOE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n}\n:root {\n  --indigo: #052456;\n  --grey: #efefef;\n  --border: #e3e3e3;\n  --white: #fff;\n  --validationError: #f32121;\n  --orange: #f15e22;\n  --diabledBtn: #ffa37d;\n}\nbutton,\nselect,\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n}\n.error {\n  color: var(--validationError);\n  margin-top: 4px;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
